<script setup>
import {defineProps} from "vue";
import WFilterButton from "@/components/WFilterButton.vue";
import useSharedData from "@/use/SharedData";

defineProps({
    title: String,
    titleIcon: String,
    titleColor: String,
    showTotal: Boolean,
    total: [Number, String],
    showFilter: Boolean,
    filter: {
        type: Object,
        defaultValue: {}
    },
});

const {rightDrawer} = useSharedData();
</script>


<template>
    <div>
        <v-navigation-drawer
            v-model="rightDrawer"
            app
            temporary
            right
            width="400"
        >
            <v-toolbar dense dark color="blue darken-2" flat>
                <v-toolbar-title>Filtre</v-toolbar-title>
            </v-toolbar>
            <v-container fluid>
                <slot name="filter"></slot>
            </v-container>
        </v-navigation-drawer>


        <v-container fluid>
            <v-card elevation="5">
                <v-toolbar class="elevation-5 mb-2" flat height="40">
                    <v-toolbar-title>
                      {{ title }}
                        <v-icon
                            v-if="titleIcon"
                            :color="titleColor"
                            left
                        >
                            {{ titleIcon }}
                        </v-icon>
                        <v-chip
                            v-if="total !== null && total !== undefined"
                            small
                            outlined
                        >
                            <strong>Total: {{ total }}</strong>
                        </v-chip>
                    </v-toolbar-title>
                    <v-divider vertical class="mr-1 ml-1"/>
                    <w-filter-button
                        v-if="showFilter"
                        :filter="filter"
                        @press="rightDrawer = true"
                    />
                    <v-btn
                        v-if="showFilter"
                        depressed
                        class="ml-2 white--text"
                        color="red"
                        small
                        @click="$emit('clearFilter')"
                    >
                        Mise à blanc
                        <v-icon right dark>mdi-trash-can</v-icon>
                    </v-btn>
                    <slot name="leftToolbar"></slot>
                    <v-spacer/>
                    <slot name="rightToolbar"></slot>
                </v-toolbar>
                <v-divider class="mb-2"/>
                <slot name="content"></slot>
            </v-card>
        </v-container>
    </div>
</template>